export default __webpack_public_path__ + "static/media/icons-edit-18-px.b45e0fac.svg";